import ParallaxBehaviour from '../../../helpers/parallax-behaviour';
import { StaticInterface } from '../../../helpers/static-interface';

export interface ITpxBoltsUtils {
  applyParallaxBehaviour(percentage: number): ParallaxBehaviour;
}

export interface IStaticTpxBoltsUtils {
  new(...args: any[]): ITpxBoltsUtils;
  init(scope?: HTMLElement): void;
}

/**
 * bolts utilities
 * @class
 */
export default class TpxBoltsUtils implements StaticInterface<IStaticTpxBoltsUtils, typeof TpxBoltsUtils> {
  #element: HTMLElement;

  /**
   * @constructor
   */
  constructor(element: HTMLElement) {
    this.#element = element;

    //only apply parallax if user has not set prefers reduced motion on their device
    const prefersReducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

    if (this.#element.dataset.parallax && !prefersReducedMotion) {
      this.applyParallaxBehaviour(parseInt(this.#element.dataset.parallax));
    }
  }

  applyParallaxBehaviour(percentage: number): ParallaxBehaviour {
    return new ParallaxBehaviour(this.#element, percentage);
  }

  /**
   * Initiate the bolts and add any parallax behaviour if necessary
   */
  static init(scope?: HTMLElement) {
    [...(scope || document).querySelectorAll('[data-animate][data-parallax]')].forEach(bolts => {
      new TpxBoltsUtils(bolts as HTMLElement);
    });
  }
}